// Validación de documentos de identidad colombianos (HU-01).

export type TipoDocumento = "CC" | "CE" | "PPT" | "PASAPORTE";

export const TIPOS_DOCUMENTO: { valor: TipoDocumento; etiqueta: string }[] = [
  { valor: "CC", etiqueta: "Cédula de ciudadanía" },
  { valor: "CE", etiqueta: "Cédula de extranjería" },
  { valor: "PPT", etiqueta: "Permiso por Protección Temporal" },
  { valor: "PASAPORTE", etiqueta: "Pasaporte" },
];

/** Quita puntos, espacios y guiones: "1.020.304.821" → "1020304821". */
export function normalizarDocumento(numero: string): string {
  return numero.replace(/[\s.\-]/g, "").toUpperCase();
}

/** Devuelve un mensaje de error o null si el documento es válido. */
export function validarDocumento(tipo: TipoDocumento, numero: string): string | null {
  const n = normalizarDocumento(numero);
  if (!n) return "Escribe el número de documento.";
  if (tipo === "CC") {
    // Las cédulas antiguas pueden tener 5 dígitos; las nuevas tienen 10.
    if (!/^\d{5,10}$/.test(n)) return "La cédula debe tener entre 5 y 10 dígitos, sin letras.";
    return null;
  }
  if (!/^[A-Z0-9]{5,12}$/.test(n)) return "El documento debe tener entre 5 y 12 letras o números.";
  return null;
}

/** "1020304821" → "•••• 4821". Así se muestra fuera de la administración (principio 3). */
export function enmascararDocumento(ultimos4: string | null | undefined): string {
  return ultimos4 ? `•••• ${ultimos4}` : "—";
}

/**
 * Las cuentas que crea la administración para quien no tiene correo entran con el número de documento. Por dentro,
 * Firebase Auth necesita un correo: este, que no recibe mensajes (la clave nueva la da la administración).
 */
export const DOMINIO_SIN_CORREO = "sin-correo.porteria-a-la-puerta.web.app";

export function correoDeDocumento(numero: string): string {
  return `${normalizarDocumento(numero).toLowerCase()}@${DOMINIO_SIN_CORREO}`;
}

export function esCorreoDeDocumento(correo: string | null | undefined): boolean {
  return !!correo && correo.toLowerCase().endsWith(`@${DOMINIO_SIN_CORREO}`);
}
